import { Component, ViewEncapsulation, ViewChild, input, computed } from '@angular/core';
import { FilterBaseComponent } from '../../classes';
import { MatOption, MatOptionModule } from '@angular/material/core';
import { MatSelect, MatSelectModule } from '@angular/material/select';
import { NHATestDirective } from '../../../../directives/test/test.directive';
import { NgClass } from '@angular/common';

@Component({
	selector: 'nha-selector',
	styleUrls: ['./selector.component.scss'],
	templateUrl: './selector.component.html',
	encapsulation: ViewEncapsulation.None,
	imports: [MatSelectModule, NgClass, MatOptionModule, NHATestDirective]
})
export class NHASelectorComponent extends FilterBaseComponent {
	@ViewChild('selector', { read: MatSelect })
	selector: MatSelect;

	disabled = input<boolean>(false);

	// Display override for the closed trigger only. Options and filter data keep their own
	// labels — select() writes the filter object it is handed straight back to FilterStateService.
	triggerLabel = input<string | null>(null);

	selectedValue = computed(() => this.filter()?.items.find((i) => i.selected)?.id ?? null);
	filterItems = computed(() => this.filter()?.items.filter((i) => !i.hidden) ?? []);
	hasItems = computed(() => this.filterItems().length > 1);

	constructor() {
		super();
	}

	onEnterKey(): void {
		this.selector.options.forEach((item: MatOption) => {
			if (item.active) {
				const filterItem = this.filter().items.find((i) => i.id === item.value);
				this.select(this.filterKey(), this.filter(), filterItem.id);
			}
		});
	}
}
